import getConfig from 'next/config';
import getGeneralImage from '../../../../util/getGeneralImage';

const { publicRuntimeConfig } = getConfig();
/**
 * @function getBannerImage -Function to get relevent banner images
 * @param {*} props - Strapi Data
 * @returns {string} - Responsive images based on desktop,mobile and tablet view
 */
const getBannerImage = props => {
  const backgroundMobile = `${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
    getGeneralImage({
      generalImageArray: props.cmsData?.bannerImages,
      key: 'backgroundImage',
      view: 'MobileViewImage',
    }).url
  }`;
  const backgroundTablet = `${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
    getGeneralImage({
      generalImageArray: props.cmsData?.bannerImages,
      key: 'backgroundImage',
      view: 'TabletViewImage',
    }).url
  }`;
  const backgroundDesktop = `${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
    getGeneralImage({
      generalImageArray: props.cmsData?.bannerImages,
      key: 'backgroundImage',
      view: 'DesktopViewImage',
    }).url
  }`;
  const foregroundMobile = `${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
    getGeneralImage({
      generalImageArray: props.cmsData?.bannerImages,
      key: 'foregroundImage',
      view: 'MobileViewImage',
    }).url
  }`;
  const foregroundTablet = `${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
    getGeneralImage({
      generalImageArray: props.cmsData?.bannerImages,
      key: 'foregroundImage',
      view: 'TabletViewImage',
    }).url
  }`;
  const foregroundDesktop = `${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
    getGeneralImage({
      generalImageArray: props.cmsData?.bannerImages,
      key: 'foregroundImage',
      view: 'DesktopViewImage',
    }).url
  }`;
  return {
    backgroundMobile,
    backgroundTablet,
    backgroundDesktop,
    foregroundMobile,
    foregroundDesktop,
    foregroundTablet,
  };
};

export default getBannerImage;
